// Owner-approved testimonials (2026-09): paraphrased representations of verified
// Google reviews. Initials exactly as owner-supplied — never invent names, photos,
// destinations, star ratings, or additional reviews.
export const TESTIMONIALS_ENABLED = true;

// Owner-approved trust treatment (2026-09): rating WITHOUT count, NO outbound link.
// "5.0 ★ on Google" only — review counts go stale and are intentionally omitted.
// A dynamic rating would require an owner-approved Google integration first.
export const GOOGLE_TRUST = "5.0 ★ on Google";

export const TESTIMONIALS = [
  {
    quote: "Inforno handled the details from beginning to end — accommodations, transportation, excursions and everything in between. We were able to relax and enjoy the trip instead of worrying about logistics.",
    initials: "T.W.",
  },
  {
    quote: "The service was professional, patient and incredibly responsive. Every question was answered, and we always knew what was happening next. The entire experience felt organized and personal.",
    initials: "K.P.",
  },
  {
    quote: "Travel can be stressful for me, but Inforno made the process feel easy. They listened to what we wanted, created an experience around us, and took away so much of the anxiety that normally comes with planning a trip.",
    initials: "D.G.",
  },
  {
    quote: "This was truly concierge-level service. From transportation and resort check-in to the experiences we had while traveling, everything flowed smoothly. We could simply show up and enjoy ourselves.",
    initials: "J.D.",
  },
  {
    quote: "We've traveled with Inforno more than once, and there's a reason we keep coming back. They are knowledgeable, responsive and genuinely invested in making the experience memorable.",
    initials: "B.H.",
  },
];
